import axios from 'axios';

/* Provenance d'un visiteur (première visite des 30 derniers jours) : Google, LinkedIn, prospection…
   Ajoutée automatiquement à chaque demande envoyée par le site (/config/candidates/apply). Aucune donnée personnelle. */
const CLE = 'ev_provenance';
const NOMS = [['google', 'Google'], ['bing', 'Bing'], ['chatgpt', 'ChatGPT'], ['openai', 'ChatGPT'], ['perplexity', 'Perplexity'], ['claude.ai', 'Claude'],
  ['gemini', 'Gemini'], ['copilot', 'Copilot'], ['linkedin', 'LinkedIn'], ['lnkd.in', 'LinkedIn'], ['facebook', 'Facebook'], ['instagram', 'Instagram'],
  ['tiktok', 'TikTok'], ['youtube', 'YouTube'], ['qwant', 'Qwant'], ['duckduckgo', 'DuckDuckGo'], ['ecosia', 'Ecosia'], ['yahoo', 'Yahoo'], ['mail.', 'Email']];

function detecter() {
  try {
    const q = new URLSearchParams(window.location.search);
    const utm = (q.get('utm_source') || '').trim();
    if (utm) return utm.charAt(0).toUpperCase() + utm.slice(1, 40);
    if (q.get('gclid')) return 'Google Ads';
    const r = String(document.referrer || '').toLowerCase();
    if (!r || r.includes(window.location.hostname.replace(/^www\./, ''))) return 'Direct';
    const n = NOMS.find(([k]) => r.includes(k));
    if (n) return n[1];
    const m = r.match(/^https?:\/\/([^/]+)/);
    return m ? m[1].replace(/^www\./, '').slice(0, 40) : 'Autre';
  } catch (e) { return ''; }
}

export function provenance() {
  try { const x = JSON.parse(localStorage.getItem(CLE) || 'null'); return (x && x.s) || ''; } catch (e) { return ''; }
}

export function installerProvenance() {
  try {
    const x = JSON.parse(localStorage.getItem(CLE) || 'null');
    const s = detecter();
    const vieux = !x || Date.now() - (x.t || 0) > 30 * 864e5;
    // on garde la première source connue ; une vraie source (Google…) remplace « Direct »
    if (s && (vieux || (x.s === 'Direct' && s !== 'Direct'))) localStorage.setItem(CLE, JSON.stringify({ s, t: Date.now() }));
  } catch (e) { /* navigation privée */ }
  const estDemande = (u) => /\/config\/candidates\/apply/.test(String(u || ''));
  axios.interceptors.request.use((cfg) => {
    if (estDemande(cfg.url) && cfg.data && typeof cfg.data === 'object' && !cfg.data.source) cfg.data = { ...cfg.data, source: provenance() };
    return cfg;
  });
  const f = window.fetch;
  if (f) window.fetch = (u, o) => {
    try {
      if (estDemande(typeof u === 'string' ? u : u && u.url) && o && typeof o.body === 'string') {
        const b = JSON.parse(o.body);
        if (b && typeof b === 'object' && !b.source) o = { ...o, body: JSON.stringify({ ...b, source: provenance() }) };
      }
    } catch (e) { /* corps non JSON : inchangé */ }
    return f(u, o);
  };
}
